import { render } from "./DefaultNoHeader.vue?vue&type=template&id=2e5309ee"
import script from "./DefaultNoHeader.vue?vue&type=script&lang=js"
export * from "./DefaultNoHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layouts/DefaultNoHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e5309ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e5309ee', __exports__)) {
    api.reload('2e5309ee', __exports__)
  }
  
  module.hot.accept("./DefaultNoHeader.vue?vue&type=template&id=2e5309ee", () => {
    api.rerender('2e5309ee', render)
  })

}


export default __exports__